import { useQuery } from '@tanstack/react-query';
import { postApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Document search results for the post document picker, keyed by the debounced term. */
export function usePostDocumentOptions(jobId: number, query: string) {
  return useQuery({
    queryKey: queryKeys.posts.documentOptions(jobId, query),
    queryFn: ({ signal }) =>
      postApiClient.getDocumentOptions(jobId, { query }, toCancelToken(signal)),
    placeholderData: (previous) => previous,
    meta: { errorContext: 'post document options' },
  });
}

/** @registry Linkable-record search results for the post link picker, keyed by the debounced term. */
export function usePostLinkOptions(jobId: number, query: string) {
  return useQuery({
    queryKey: queryKeys.posts.linkOptions(jobId, query),
    queryFn: ({ signal }) =>
      postApiClient.getLinkOptions(jobId, { query }, toCancelToken(signal)),
    placeholderData: (previous) => previous,
    meta: { errorContext: 'post link options' },
  });
}
